<template>
  <div>

    <b-row class="border-bottom mb-2">
      <b-col>
        <h4>Object Details</h4>
      </b-col>
    </b-row>

    <b-row class="mb-2">

      <b-col>
        <p><b>Name:</b></p>
        <kbd>{{ newObject.info.name }}</kbd>
      </b-col>

      <b-col>
        <p> <b>Type</b></p>
        <kbd v-if="newObject.info.type.name !== undefined">{{ newObject.info.type.name }}</kbd>
      </b-col>

      <b-col>
        <p> <b>Serial Number</b></p>
        <kbd>{{ newObject.info.serialNumber }}</kbd>
      </b-col>

    </b-row>

    <b-row class="border-bottom mb-2">
      <b-col>
        <h4>Object Model</h4>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <p>
          <b>Manufacturer</b>
        </p>
        <kbd> {{ newObject.info.manufacturer }}</kbd>
      </b-col>

      <b-col>
        <p>
          <b>Model</b>
        </p>
        <kbd>
          {{ newObject.info.model }}
        </kbd>
      </b-col>

      <b-col>
        <p>
          <b>Model Number</b>
        </p>
        <kbd>
          {{ newObject.info.modelNumber }}
        </kbd>
      </b-col>
    </b-row>

    <b-row class="border-bottom mt-2">
      <b-col>
        <h4>Object Properties</h4>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-table
        :items="newObject.properties"
        :fields="propertyFields"
        small
        responsive
        show-empty
      />
    </b-row>

    <b-row class="border-bottom mt-2">
      <b-col>
        <h4>Object Devices</h4>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-table
        :items="newObject.devices"
        :fields="deviceFields"
        small
        responsive
        show-empty
      />
    </b-row>

    <b-row class="border-bottom mb-2 mt-2">
      <b-col>
        <h4>Site</h4>
      </b-col>
    </b-row>

    <div
      v-if="newObject.site && 'id' in newObject.site"
      class=" mb-2"
    >
      <b-row class="mb-2">
        <b-col>
          <p>
            <b>Name</b>
          </p>
          <kbd>
            {{ newObject.site.name }}
          </kbd>
        </b-col>

        <b-col>
          <p>
            <b>Address</b>
          </p>
          <kbd>
            {{ newObject.site.address }}
          </kbd>
        </b-col>

        <b-col>
          <p>
            <b>City</b>
          </p>
          <kbd>
            {{ newObject.site.city }}
          </kbd>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col>
          <p>
            <b>Sub Region</b>
          </p>
          <kbd>
            {{ newObject.site.subRegion }}
          </kbd>
        </b-col>
        <b-col>
          <p>
            <b>Region</b>
          </p>
          <kbd>
            {{ newObject.site.region }}
          </kbd>
        </b-col>
        <b-col>
          <p>
            <b>Country</b>
          </p>
          <kbd>
            {{ newObject.site.country }}
          </kbd>
        </b-col>
      </b-row>

    </div>
    <div
      v-else
      class="mb-2"
    >
      <b-row class="mb-2">
        <b-col>
          <p>
            <b>No Site Selected</b>
          </p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
} from 'bootstrap-vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BRow,
    BCol,
    BTable,

  },
  props: {
    newObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      summary: [],
      propertyFields: [
        { key: 'name', label: ' Name', sortable: true },
        { key: 'value', label: 'Value', sortable: true },
        { key: 'unit', label: 'Unit', sortable: true },
      ],
      deviceFields: [
        { key: 'name', label: ' Name', sortable: true },
        { key: 'serialNumber', label: 'Serial Number', sortable: true },
      ],
    }
  },
  watch: {
    newObject: {
      handler(newVal) {
        this.newObject = newVal
      },
      deep: true,
    },
  },
}
</script>

<style>

</style>
